module.exports = __webpack_public_path__ + "8ab481a817452bca9e6e28af1f2bfdf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/pattern-bg/pattern-bg-4.png
// module id = 408
// module chunks = 0